export enum AisErpStatus {

    // Успешная выгрузка
    Success = "Success",

    // Ошибка при выгрузке
    Error = "Error"
}

export const AisErpStatusUtil = {
    getStringValue: (status: AisErpStatus | null): string => {
        switch (status) {
            case AisErpStatus.Success:
                return "Успешно";
            case AisErpStatus.Error:
                return "Ошибка";
            default:
                return "Ожидает отправки";
        }
    }
}

